/** Creates a copy of the essential public properties of a trackable object, excluding any that are excessively bulky. */
export abstract class Trackable<T = any> {
  public abstract getTrackingCopy(): Partial<T>;
}
